import { algoliaBaseHelper } from "./algoliaBaseHelper";
import FavoriteApi from "@/services/api/favoritesApi";
const FavoriteApiService = new FavoriteApi();

export const algoliaBrandHelper = {
  mixins: [algoliaBaseHelper],
  data() {
    return {
      defaultBrandFacets: "*,status,based_in,lead_time_from,product_categories,values",
    };
  },
  methods: {
    setIndex: function (sort) {
      return this.algoliaClient.initIndex(`${this.$env.getOrigin()}_${sort}`);
    },
    getBrandsOnSearch(params) {
      const { sortBy, page } = params || {};

      this.loading = true;
      this.searchIndex = this.setIndex(sortBy);
      this.searchIndex.clearCache();
      this.searchIndex
        .search({
          page: (page || 1) - 1,
          hitsPerPage: this.pagination.limit,
          minProximity: 1,
          facets: this.defaultBrandFacets,
          facetFilters: this.getFacetFiltersFromParams(params),
          numericFilters: this.getNumericFiltersFromParams(params),
        })
        .then((response, err) => {
          if (err) {
            this.$swal("Attention", this.$utils.formatErrorMessage("brands"));
            return;
          }
          this.pagination.limit = response.hitsPerPage;
          this.pagination.totalCount = response.nbHits;
          this.brands = response.hits.map((brand) => {
            return {
              ...brand,
              is_fav: this.favoriteBrandIDsList.includes(brand.id),
            };
          });

          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response) {
            this.$swal("Attention", error.response.data.error_message);
          } else {
            this.$logger.notify(new Error(error));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    applyFavorites: function (items) {
      return items.map((item) => ({
        ...item,
        ...{ is_fav: this.favoriteList.includes(item.id) },
      }));
    },
    getFacetFiltersFromParams(params) {
      const { brands, brand_values, location, categories } = params;
      return [
        ...[["status:APPROVED", "status:REGISTERED"]],
        ...["is_published:true"],
        ...[this.$utils.arrayify(brands).map((brand) => `brand.id:${brand}`)],
        ...[this.$utils.arrayify(brand_values).map((brandValue) => `values: ${brandValue}`)],
        ...[this.$utils.arrayify(categories).map((category) => `product_categories:${category}`)],
        ...[this.$utils.arrayify(location).map((state) => `address.state:${state}`)],
      ];
    },
    getNumericFiltersFromParams(params) {
      const { price_from, price_to, mov, lead_time_to } = params;
      return [
        price_from ? `pos_price >= ${price_from}` : [],
        price_to ? `pos_price <= ${price_to}` : [],
        mov ? "minimum_order_value<=" + mov : [],
        lead_time_to ? `lead_time_from <=${lead_time_to}` : [],
      ];
    },
    async getFavoriteBrands() {
      if (this.$session.getUserInfo() === null || this.$session.getUserInfo()?.role !== "RETAILER") {
        return;
      }

      try {
        const { data } = await FavoriteApiService.getFavoriteBrands();
        this.favoriteBrandIDsList = data.brand_ids || [];
      } catch (error) {
        this.$logger.notify(new Error(error));
      }
    },
  },
};
